/**
 *
 *
 */

import { Content, Statistic } from 'components';

/**----------------------------------------
 * [Component] 총관리자: 상품목록 > 요약정보
 * ----------------------------------------
 */
const ProductSummary = ({ products }) => {
  /* ===== Functions ===== */
  /**
   *
   * --
   */
  const getSummaryCount = (type) => {
    if (type === 'total') {
      return products.length;
    } else if (type === 'sales_wait') {
      return products.filter((product) => product.product_status === 'WAIT')
        .length;
    } else if (type === 'sales') {
      return products.filter((product) => product.product_status === 'NORMAL')
        .length;
    } else if (type === 'sold_out') {
      return products.filter((product) => product.product_status === 'SOLDOUT')
        .length;
    } else if (type === 'approve_wait') {
      return products.filter((product) => product.application_status === 'WAIT')
        .length;
    } else if (type === 'sales_stop') {
      return products.filter((product) => product.product_status === 'STOP')
        .length;
    } else if (type === 'sales_end') {
      return products.filter((product) => product.product_status === 'END')
        .length;
    }

    return 0;
  };

  /* ===== Render ===== */
  // JSX: start
  return (
    <Content
      fullWidth
      padding={0}
      backgroundColor={'none'}
      style={{ marginBottom: 4, display: 'flex', justifyContent: 'center' }}
    >
      {[
        { title: '전체', value: getSummaryCount('total') },
        { title: '판매대기', value: getSummaryCount('sales_wait') },
        { title: '판매중', value: getSummaryCount('sales') },
        { title: '품절', value: getSummaryCount('sold_out') },
        // { title: '승인대기', value: getSummaryCount('approve_wait') },
        { title: '판매중지', value: getSummaryCount('sales_stop') },
        { title: '판매종료', value: getSummaryCount('sales_end') },
      ].map((_item, _index) => (
        <div
          key={`${_item.label}-${_index}`}
          style={{
            background: '#FFFFFF',
            borderRadius: 4,
            width: `calc(100% / 6)`,
            margin: '0 2px',
            padding: '24px 15px',
          }}
        >
          <Statistic
            title={_item.title}
            value={_item.value}
            suffix={'건'}
            direction={'row'}
            style={{ justifyContent: 'center' }}
          />
        </div>
      ))}
    </Content>
  ); // JSX: end
};

export default ProductSummary;
